import { 
    DAILY_DEVICE_AUDIT_REQUEST,
    DAILY_DEVICE_AUDIT_RESULT
} from 'Redux/actionTypes'

export const dailyDeviceAuditRequest = (data) => ({
    type: DAILY_DEVICE_AUDIT_REQUEST,
    payload: data
})

export const dailyDeviceAuditResult = (data) => ({
    type: DAILY_DEVICE_AUDIT_RESULT,
    payload: data
})